import getPreviewPathInfo from '../getPreviewPathInfo';
import {
  isAbsoluteUrl,
  isBrowser,
  isFileUrl,
  isMailToUrl,
  isTelephoneUrl,
} from '../../index';
import getPreviewModeFromPath from '../getPreviewModeFromPath';

export interface AddPreviewPrefixToUrlProps {
  pathname?: string;
  hostname?: string;
  url: string;
  removeTrailingSlash?: boolean;
}

export default function addPreviewPrefixToUrl(
  props: AddPreviewPrefixToUrlProps,
) {
  const isClient = isBrowser();

  const {
    hostname = isClient ? window.location.hostname : '',
    pathname = isClient ? window.location.pathname : '',
    url = '',
    removeTrailingSlash,
  } = props;

  const { isPreviewSite, previewUrlPrefix } = getPreviewPathInfo(
    hostname,
    pathname,
  );

  const { previewMode } = getPreviewModeFromPath(url);
  const hasAlreadyAddedPreviewMode = !!previewMode;

  if (
    !isPreviewSite ||
    hasAlreadyAddedPreviewMode ||
    isAbsoluteUrl(url) ||
    isMailToUrl(url) ||
    isTelephoneUrl(url) ||
    isFileUrl(url)
  ) {
    return url;
  }

  const finalUrl = url.startsWith('/')
    ? `/${previewUrlPrefix}${url}`
    : `/${previewUrlPrefix}/${url}`;

  return removeTrailingSlash ? finalUrl.substring(1) : finalUrl;
}
